import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useSortingStrategyMutation = createMutationHook(
  CollectionsApiClient.updateSortingStrategy,
  {
    mutationKey: ['updateSortingStrategy'],
  },
)
